import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import { RiskScoreStatusChip } from '@packages/components/risk-score/risk-score-status-chip/risk-score-status-chip';
import type { GridRenderCellParams } from '@packages/fenrir/components/datagrid';

export const RiskScoreCell = (params: GridRenderCellParams) => {
  return params.value || params.value === 0 ? (
    <RiskScoreStatusChip score={params.value} />
  ) : (
    <NoDataEnDash />
  );
};
